import * as React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact, {BugsnagErrorBoundary} from "@bugsnag/plugin-react";
import {FC, ReactNode, useMemo} from "react";
import { useBugsnagConfig } from './BugsnagConfigContext';

let bugsnagInitialized = false;

interface Props {
  children?: ReactNode,
  fallbackComponent?: FC
}

const FallbackComponent = () => (<div>
  <p>Er is een probleem opgetreden tijdens het verwerken van de gegevens.</p>
</div>)

const ErrorBoundary: FC<Props> = ({children, fallbackComponent = FallbackComponent}) => {
  const {bugsnagApiKey} = useBugsnagConfig();

  const Boundary = useMemo<BugsnagErrorBoundary|null>(() => {
    if (!bugsnagApiKey) {
      return null;
    }

    if (!bugsnagInitialized) {
      try {
        Bugsnag.start({
          apiKey: bugsnagApiKey,
          appVersion: '1.0.0',
          plugins: [new BugsnagPluginReact()],
          onError: ({originalError}) => {
            Bugsnag.addMetadata('event', [originalError]);
          }
        });
        bugsnagInitialized = true;
      } catch (error) {
        bugsnagInitialized = true;
      }
    }

    return Bugsnag.getPlugin('react').createErrorBoundary(React);
  }, [bugsnagApiKey]);

  return (
    Boundary ? <Boundary FallbackComponent={fallbackComponent}>{children}</Boundary> : <>{children}</>
  );
}

export default ErrorBoundary;
